import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const appIndividualAssetsAdapter = createEntityAdapter({})

const initialState = appIndividualAssetsAdapter.getInitialState()

export const appIndividualAssetsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAppIndividualAssets: builder.query({
            query: () => ({
                url: '/appindasset',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedappindasset = responseData.map(appindasset => {
                    appindasset.id = appindasset._id
                    return appindasset
                });
                return appIndividualAssetsAdapter.setAll(initialState, loadedappindasset)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'APPINDIVASSET', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'APPINDIVASSET', id }))
                    ]
                } else return [{ type: 'APPINDIVASSET', id: 'LIST' }]
            }
        }),
        addNewAppIndividualAsset: builder.mutation({
            query: initialUserData => ({
                url: '/appindasset',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'APPINDIVASSET', id: "LIST" }
            ]
        }),        
        updateAppIndividualAsset: builder.mutation({
            query: initialUserData => ({
                url: '/appindasset',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'APPINDIVASSET', id: arg.id }
            ]
        }),        
        deleteAppIndividualAsset: builder.mutation({
            query: ({ id }) => ({
                url: `/appindasset`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'APPINDIVASSET', id: arg.id }
            ]
        }),
    }),
})


export const {
    useGetAppIndividualAssetsQuery,
    useAddNewAppIndividualAssetMutation,
    useUpdateAppIndividualAssetMutation,
    useDeleteAppIndividualAssetMutation,
} = appIndividualAssetsApiSlice

// returns the query result object
export const selectAppIndividualAssetsResult = appIndividualAssetsApiSlice.endpoints.getAppIndividualAssets.select()

// creates memoized selector
const selectAppIndividualAssetsData = createSelector(
    selectAppIndividualAssetsResult,
    appIndividualAssetsResult => appIndividualAssetsResult.data // normalized state object with ids & entities
)

// getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllAppIndividualAssets,
    selectById: selectAppIndividualAssetById,
    selectIds: selectAppIndividualAssetIds
    // Pass in a selector that returns the users slice of state
} = appIndividualAssetsAdapter.getSelectors(state => selectAppIndividualAssetsData(state) ?? initialState)
